module.exports = __webpack_public_path__ + "static/img/smartphone-image.a5919a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smartphone-image.jpg
// module id = 7/Cc
// module chunks = 1